<template>
  <button class="app-button"
          :class="[
             `app-button_${size}`,
             `app-button_${type}`,
             `app-button_${color}`,
             {
               'app-button_icon-only': !$slots.default
             }
          ]"
          @click="$emit('click')"
  >
    <span v-if="icon" class="app-button__icon">
      <app-icon :name="icon" size="1.28rem" />
    </span>

    <span class="app-button__text">
      <slot />
    </span>

  </button>
</template>

<script>
export default {
  name:  "AppButton",
  props: {
    size:  {
      type:    String,
      default: "default",
    },
    type:  {
      type:    String,
      default: 'fill',
    },
    color: {
      type:    String,
      default: 'primary',
    },
    icon:  {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.app-button {
  display: inline-block;
  appearance: none;
  border-radius: 2px;
  padding: 6px 16px;
  font: inherit;
  font-size: 1rem;
  min-width: 100px;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  transition: all .15s ease-out;

  &_big {
    padding: 14px 28px;
    min-width: 120px;
  }

  &_small {
    padding: 4px 8px;
    min-width: 80px;
  }

  &[disabled] {
    opacity: .5;
    pointer-events: none;
    cursor: not-allowed;
  }

  @mixin buttonColor($type, $hover-color, $text-color: #fff) {
    &_#{$type} {
      background: rgba(var(--app-#{$type}), 1);
      border-color: rgba(var(--app-#{$type}), 1);
      color: $text-color;

      &:visited {
        color: $text-color;
      }

      &.app-button_border {
        &, &:visited {
          color: rgba(var(--app-#{$type}), 1);
          background: transparent;
        }
      }

      &:hover {
        background: $hover-color;
        color: $text-color;
      }
    }
  }

  @include buttonColor('primary', #5647ec);
  @include buttonColor('success', #23b363);
  @include buttonColor('danger', #e63738);
  @include buttonColor('warning', #ff8e22);

  &__icon {
    display: inline-flex;
    vertical-align: middle;
    width: 1.28rem;
    height: 1.28rem;
    justify-content: center;
    align-items: center;
  }

  &__text {
    display: inline-block;
    vertical-align: middle;
  }

  &__icon + &__text {
    margin-left: 5px;
  }

  &_icon-only {
    padding-left: 6px;
    padding-right: 6px;
    min-width: 1px;

    .app-button__text {
      display: none;
    }
  }


  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #cbd6ee;
  }
}
</style>
